export default __webpack_public_path__ + "static/media/image-2.c452dd5c.gif";